import { createTheme } from '@mui/material/styles';

// Scoped to Profile & KYC, including MUI's portalled menus. Do not change the
// global palette: other pages explicitly style both light and dark surfaces.
const surface = '#102C46';
const secondary = '#D8E5F2';
const focus = '#A9E889';
export const profileKYCTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#7ED957', contrastText: '#10210A' },
    background: { default: '#0A3D62', paper: surface },
    text: { primary: '#FFFFFF', secondary, disabled: '#B8C9D9' },
    error: { main: '#FFB4AB' },
    warning: { main: '#FFE08A' },
    success: { main: '#A9E889' },
    info: { main: '#B6DDFF' },
  },
  shape: { borderRadius: 12 },
  typography: { button: { textTransform: 'none', fontWeight: 700 } },
  components: {
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none', overflowWrap: 'anywhere' } } },
    MuiTextField: { defaultProps: { fullWidth: true } },
    MuiInputBase: { styleOverrides: {
      root: { fontSize: 16, color: '#FFFFFF', backgroundColor: surface, minWidth: 0 },
      input: {
        '&::placeholder': { color: '#B8C9D9', opacity: 1 },
        '&.Mui-disabled': { WebkitTextFillColor: '#B8C9D9', opacity: 1 },
        '&:-webkit-autofill': { WebkitTextFillColor: '#FFFFFF', WebkitBoxShadow: `0 0 0 100px ${surface} inset` },
      },
    } },
    MuiOutlinedInput: { styleOverrides: { root: {
      '& .MuiOutlinedInput-notchedOutline': { borderColor: '#829FB8' },
      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: secondary },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: focus, borderWidth: 2 },
      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: '#829FB8', borderStyle: 'dashed' },
    } } },
    MuiInputLabel: { styleOverrides: { root: { color: secondary, '&.Mui-focused': { color: focus }, '&.Mui-disabled': { color: '#B8C9D9' } } } },
    MuiFormHelperText: { styleOverrides: { root: { color: secondary, fontSize: '0.875rem', marginInline: 0 } } },
    MuiFormControlLabel: { styleOverrides: { root: { marginLeft: 0, marginRight: 0, alignItems: 'flex-start' }, label: { paddingTop: 9, overflowWrap: 'anywhere' } } },
    MuiCheckbox: { styleOverrides: { root: { color: secondary } } },
    MuiSelect: { styleOverrides: { icon: { color: secondary }, select: { minHeight: '1.5em' } } },
    MuiMenuItem: { styleOverrides: { root: {
      minHeight: 48, whiteSpace: 'normal', color: '#FFFFFF',
      '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: '#214969', color: '#FFFFFF' },
      '&.Mui-focusVisible': { backgroundColor: '#214969', outline: `2px solid ${focus}`, outlineOffset: -2 },
    } } },
    MuiAutocomplete: { styleOverrides: {
      paper: { backgroundColor: surface, color: '#FFFFFF', border: '1px solid #829FB8' },
      listbox: { maxHeight: 'min(280px, 45dvh)', overscrollBehavior: 'contain', WebkitOverflowScrolling: 'touch',
        '& .MuiAutocomplete-option': { minHeight: 48, overflowWrap: 'anywhere' },
        '& .MuiAutocomplete-option.Mui-focused, & .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused': { backgroundColor: '#214969', color: '#FFFFFF' },
        '& .MuiAutocomplete-option.Mui-focusVisible': { outline: `2px solid ${focus}`, outlineOffset: -2 },
      },
      popper: { zIndex: 1500 },
      loading: { color: secondary }, noOptions: { color: secondary },
    } },
    MuiButton: { styleOverrides: { root: {
      minHeight: 48, paddingInline: 16,
      '&.Mui-focusVisible': { outline: `3px solid ${focus}`, outlineOffset: 3 },
    }, contained: {
      '&.Mui-disabled': { backgroundColor: '#344B60', color: '#D8E5F2', border: '1px dashed #829FB8' },
    } } },
    MuiAlert: { styleOverrides: { message: { minWidth: 0, overflowWrap: 'anywhere' }, action: { flexShrink: 0 } } },
  },
});

export const requestedChangeMenuProps = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
  marginThreshold: 16,
  slotProps: { paper: { sx: { mt: 0.5, maxHeight: 'min(280px, 50dvh)', maxWidth: 'calc(100vw - 32px)', bgcolor: surface, color: '#FFFFFF', border: '1px solid #829FB8', overscrollBehavior: 'contain' } } },
};
